import React, { useEffect, useRef, useState } from "react";
// import { setCurrentUser } from "../store/actions/authActions.js";
import { initFlowbite } from "flowbite";
import { NavLink } from "react-router-dom";
import { usePostHog } from '@posthog/react';
import TableSearchBar from "../../components/TableSearchBar";
import instance, { fetchResponseRatingDueDate } from "../../api/api";
import { Loader } from "../../components/Loader";
import PerspectiveBadge from "../../components/PerspectiveBadge";
import GetScoreColor from "../../utils/GetScoreColor";
import { getRiskScoreColorClass } from "../../utils/riskLevel";
import { useTenant } from "../../context/Tenant/TenantContext";
// const config = localStorage.getItem("parameters");
import {
  createColumnHelper,
  flexRender,
  getCoreRowModel,
  useReactTable,
  getSortedRowModel,
  SortingState,
} from "@tanstack/react-table";
// const config = localStorage.getItem("parameters");

type Risk = {
  id: string;
  riskName: string;
  perspective: string;
  description: string;
  source: string;
  rootCause: string;
  objective: string;
  riskConsequence: string;
  responseText: string;
  inherentRiskScore: number;
  residualRiskScore: number;
  responseTextScore: number;
  riskConsequenceScore: number;
  cumulativeRiskScore: number;
};
function RiskResponseScoring() {
  const posthog = usePostHog();
  const { config, loading: tenantLoading } = useTenant();
  const [isLoadingRisks, setIsLoadingRisks] = useState(false);
  const [allRiskswithResponses, setAllRisksWithResponses] = useState([]);
  const [currentRiskDetails, setCurrentRiskDetails] = useState<any>([]);
  const [isSubmittingScores, setIsSubmittingScores] = useState(false);

  const [isEditDrawerOpen, setIsEditDrawerOpen] = useState(false);

  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(25);
  const [searchTerm, setSearchTerm] = useState("");

  // const [dueDate, setDueDate] = useState<any>(null);
  const [isResponseScoringLocked, setIsResponseScoringLocked] = useState(false);
  const today = new Date();

  const department = localStorage.getItem("department");
  const [riskScores, setRiskScores] = useState<[string, string][]>([]);

  const [highlightedRiskId, setHighlightedRiskId] = useState<any>(null);
  const [sorting, setSorting] = useState<SortingState>([]);

  useEffect(() => {
    if (config?.Acceptance) setRiskScores(Object.entries(config.Acceptance));
  }, [config]);

  const getAllRisks = async () => {
    try {
      setIsLoadingRisks(true);
      const riskRegisterResponse = await instance.get(
        "/api/employee/riskRegister/SELECTION_COMPLETE"
      );
      const riskResponse = await instance.get(
        // "/api/employee/riskResponse/user/risk-responses"
        "/api/employee/riskResponse/risk-responses/PLAN_UNDER_REVIEW"
      );

      const riskResponseScoresResponse = await instance.get(
        "/api/employee/riskResponse/scores"
      );

      const riskRegister = riskRegisterResponse.data.data ?? [];
      const riskResponses = riskResponse.data.data ?? [];
      const riskResponseScores = riskResponseScoresResponse.data;
      const riskWithResidualRisk =
        riskResponseScoresResponse.data.dataWithInherentRisk ?? [];

      const allCombinedRisks = riskResponses.map((riskResponse: any) => {
        const risks = riskRegister.find(
          (risk: any) => riskResponse.riskRegisterId === risk.id
        );
        return {
          ...riskResponse,
          riskName: risks?.riskName,
          perspective: risks?.perspective,
          objective: risks?.objective,
          riskRegisterId: risks?.id,
          riskResponseId: riskResponse ? riskResponse.id : null,
          riskConsequence: riskResponse ? riskResponse.riskConsequence : "--",
          responseText: riskResponse ? riskResponse.responseText : "--",
        };
      });

      const combinedRisksWithScores = allCombinedRisks.map((risk: any) => {
        return {
          ...risk,
        };
      });

      const combinedRisksWithResponseScores = combinedRisksWithScores.map(
        (risk: any) => {
          const score = (riskResponseScores.data ?? []).find(
            (score: any) => risk.riskResponseId === score.riskResponseId
          );

          let scoresWithSuggestions: any[] = [];
          for (const suggestion of riskResponseScores.riskResponses ?? []) {
            if (suggestion.riskRegisterId === risk.id) {
              scoresWithSuggestions.push(suggestion.RiskResponseUserScore);
            }
          }
          return {
            ...risk,
            // responseTextSuggestion: scoresWithSuggestions ? scoresWithSuggestions[1].responseTextSuggestion : "",
            // riskConsequenceSuggestion: scoresWithSuggestions ? scoresWithSuggestions[1].riskConsequenceSuggestion : "",
            responseTextScore: score ? score._avg.responseTextScore : 0,
            riskConsequenceScore: score ? score._avg.riskConsequenceScore : 0,
            cumulativeRiskScore: score ? score.cumulativeRiskScore : 0,
          };
        }
      );

      const combinedRisksWithInherentScores =
        combinedRisksWithResponseScores.map((risk: any) => {
          const score = riskWithResidualRisk.find(
            (score: any) => risk.riskRegisterId === score.riskRegisterId
          );
          return {
            ...risk,
            inherentRiskScore: score?.inherentRiskScore
              ? score.inherentRiskScore
              : 0,
            residualRiskScore: score?.residualRiskScore
              ? score.residualRiskScore
              : 0,
          };
        });

      // sort risks by descending order of inherent risk score
      combinedRisksWithInherentScores.sort(
        (a: any, b: any) => b.residualRiskScore - a.residualRiskScore
      );

      setAllRisksWithResponses(combinedRisksWithInherentScores);
      setIsLoadingRisks(false);
      initFlowbite();
    } catch (error) {
      setIsLoadingRisks(false);
      return error;
    }
  };

  useEffect(() => {
    const fetchDueDate = async () => {
      const theDueDate = await fetchResponseRatingDueDate();
      // setDueDate(FormatDueDates(theDueDate));

      if (theDueDate && theDueDate < today) {
        // setIsResponseScoringLocked(true);
        setIsResponseScoringLocked(false);
      } else {
        setIsResponseScoringLocked(false);
      }
    };

    fetchDueDate();

    getAllRisks();
    posthog.capture('page_viewed', { page: 'employee_risk_response_scoring' });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleScoreResponseDrawer = (riskId: string) => {
    const risk = allRiskswithResponses.find((risk: Risk) => risk.id === riskId);
    setIsEditDrawerOpen(true);
    setHighlightedRiskId(riskId);
    setCurrentRiskDetails(risk);
  };

  const handleScoreResponses = async (e: any) => {
    e.preventDefault();
    setIsSubmittingScores(true);
    try {
      await instance.post(
        `/api/employee/riskResponse/score/create/${currentRiskDetails.riskResponseId}`,
        {
          riskConsequenceSuggestion:
            currentRiskDetails.riskConsequenceSuggestion,
          riskConsequenceScore: currentRiskDetails.riskConsequenceScore
            ? Number(currentRiskDetails.riskConsequenceScore)
            : 0,
          responseTextSuggestion: currentRiskDetails.responseTextSuggestion,
          responseTextScore: currentRiskDetails.responseTextScore
            ? Number(currentRiskDetails.responseTextScore)
            : 0,
        }
      );
      posthog.capture('employee_risk_response_scored', {
        riskResponseId: currentRiskDetails.riskResponseId,
        responseTextScore: currentRiskDetails.responseTextScore,
        riskConsequenceScore: currentRiskDetails.riskConsequenceScore,
      });
      setIsSubmittingScores(false);
      await getAllRisks();
    } catch (error) {
      setIsSubmittingScores(false);
      return error;
    }
  };

  const editDrawerRef = useRef<any>(null);

  useEffect(() => {
    const handleClickOutside = (event: any) => {
      if (
        editDrawerRef.current &&
        !editDrawerRef.current.contains(event.target)
      ) {
        setIsEditDrawerOpen(false);
        setHighlightedRiskId(null);
      }
    };

    if (isEditDrawerOpen) {
      document.addEventListener("mousedown", handleClickOutside);
    } else {
      setHighlightedRiskId(null);
      document.removeEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [isEditDrawerOpen]);

  const handlePageChange = (pageNumber: number) => {
    setCurrentPage(pageNumber);
  };

  // Calculate the items to display based on the current page and items per page
  const paginatedRisks = React.useMemo(() => {
    let risksToDisplay = allRiskswithResponses;

    // Apply search filter
    if (searchTerm) {
      risksToDisplay = risksToDisplay.filter((risk: any) =>
        Object.values(risk).some((value) =>
          String(value).toLowerCase().includes(searchTerm.toLowerCase())
        )
      );
    }

    const indexOfLastItem = currentPage * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;
    return risksToDisplay.slice(indexOfFirstItem, indexOfLastItem);
  }, [allRiskswithResponses, currentPage, itemsPerPage, searchTerm]);

  const totalPages = Math.ceil(allRiskswithResponses.length / itemsPerPage);

  const columnHelper = createColumnHelper<Risk>();
  const columns = [
    columnHelper.accessor("riskName", {
      header: () => <span className="whitespace-nowrap">Risk Name</span>,
      cell: (info) => info.renderValue(),
      enableSorting: true,
      footer: (info) => info.column.id,
    }),
    columnHelper.accessor("perspective", {
      header: () => "Perspective",
      cell: (info) => <PerspectiveBadge value={info.getValue()} />,
      enableSorting: true,
      footer: (info) => info.column.id,
    }),
    columnHelper.accessor("objective", {
      header: () => "Objective",
      cell: (info) => info.renderValue(),
      enableSorting: true,
      footer: (info) => info.column.id,
    }),
    columnHelper.accessor("responseText", {
      header: () => <span className="whitespace-nowrap">Risk Response</span>,
      cell: (info) => (
        <div className="flex flex-col h-full justify-between gap-10">
          <div className="h-full">{info.getValue()}</div>
          <div className="font-bold h-full text-gray-500">
            Response Score:{" "}
            <span
              className={GetScoreColor(info.row.original.responseTextScore)}
            >
              {info.row.original.responseTextScore}
            </span>
          </div>
        </div>
      ),
      enableSorting: true,
      footer: (info) => info.column.id,
    }),
    columnHelper.accessor("inherentRiskScore", {
      header: () => <span className="whitespace-nowrap">Inherent Risk Score</span>,
      cell: (info) => info.renderValue(),
      enableSorting: true,
      footer: (info) => info.column.id,
    }),
    columnHelper.accessor("residualRiskScore", {
      header: () => <span className="whitespace-nowrap">Residual Risk Score</span>,
      cell: (info) => (
        <div
          className={getRiskScoreColorClass(info.row.original.residualRiskScore, config?.RiskLevels)}
        >
          {info.getValue()}
        </div>
      ),
      enableSorting: true,
      footer: (info) => info.column.id,
    }),
    columnHelper.display({
      id: "actions",
      header: () => <span>Actions</span>,
      enableSorting: false,
      cell: ({ row }) => (
        <button
          type="button"
          className={`text-caribbeanCurrent whitespace-nowrap hover:text-white border border-caribbeanCurrent hover:bg-caribbeanCurrent focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-xs px-11 py-2 text-center inline-flex me-2 mb-2 dark:border-blue-500 dark:text-blue-500 dark:hover:text-white dark:hover:bg-caribbeanCurrent dark:focus:ring-blue-800 ${
            isResponseScoringLocked
              ? "bg-gray-400 cursor-not-allowed text-white border-none hover:bg-gray-400"
              : "hover:bg-blue-800 focus:ring-blue-300 dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800"
          }`}
          disabled={isResponseScoringLocked}
          data-drawer-target="drawer-assessment-risk-response"
          data-drawer-show="drawer-assessment-risk-response"
          data-drawer-placement="right"
          aria-controls="drawer-assessment-risk-response"
          onClick={() => handleScoreResponseDrawer(row.original.id)}
        >
          <svg
            className="w-4 h-4 text-white-800 dark:text-white me-2"
            aria-hidden="true"
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            fill="none"
            viewBox="0 0 24 24"
          >
            <path
              stroke="currentColor"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="2"
              d="m14.304 4.844 2.852 2.852M7 7H4a1 1 0 0 0-1 1v10a1 1 0 0 0 1 1h11a1 1 0 0 0 1-1v-4.5m2.409-9.91a2.017 2.017 0 0 1 0 2.853l-6.844 6.844L8 14l.713-3.565 6.844-6.844a2.015 2.015 0 0 1 2.852 0Z"
            />
          </svg>
          Comment
        </button>
      ),
    }),
  ];

  const table = useReactTable<Risk>({
    data: paginatedRisks,
    columns,
    getCoreRowModel: getCoreRowModel(),
    getSortedRowModel: getSortedRowModel(),
    state: { sorting },
    onSortingChange: setSorting,
  });

  if (tenantLoading || !config) {
    return (
      <div className="flex justify-center items-center h-screen">
        <Loader size="xl" />
      </div>
    );
  }

  return (
    <>
      {/* <!-- Breadcrumb --> */}
      <nav
        className="justify-between  py-3 text-gray-700  sm:flex bg-gray-50"
        aria-label="Breadcrumb"
      >
        <ol className="inline-flex items-center mb-3 space-x-1 md:space-x-2 rtl:space-x-reverse sm:mb-0">
          <li>
            <div className="flex items-center">
              <NavLink
                to=""
                className=" text-sm font-medium text-gray-700 hover:text-blue-600  dark:text-gray-400 dark:hover:text-white"
              >
                Risk Response
              </NavLink>
            </div>
          </li>

          <li aria-current="page">
            <div className="flex items-center ">
              <svg
                className="rtl:rotate-180 w-3 h-3 mx-1 text-gray-400"
                aria-hidden="true"
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 6 10"
              >
                <path
                  stroke="currentColor"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="m1 9 4-4-4-4"
                />
              </svg>
              <span className="mx-1 text-sm font-medium text-gray-500 md:mx-2 dark:text-gray-400">
                Invite Comments
              </span>
            </div>
          </li>
        </ol>
      </nav>
      <h1 className="text-xl mb-3 font-semibold text-gray-700">
        Risk Response Comment
      </h1>

      {/* <p className="text-caribbeanCurrent font-semibold">Due date: {dueDate}</p> */}
      <form className="flex max-w-sm my-4 justify-center items-center">
        <label
          htmlFor="countries"
          className="block mb-2 text-md font-medium text-gray-900 dark:text-white"
        >
          Department
        </label>
        <span className="ml-5 bg-gray-50 border border-caribbeanCurrent  text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500">
          {department}
        </span>
      </form>

      <div className="border-2 border-dashed rounded-lg border-gray-300 dark:border-gray-600 mb-4">
        <div className="rt-wrap relative overflow-x-auto sm:rounded-lg">
          <table className="w-full text-sm text-left rtl:text-right text-gray-500 dark:text-gray-400">
            <caption className="p-5 text-lg font-semibold text-left rtl:text-right text-gray-900 bg-white dark:text-white dark:bg-gray-800">
              <div className="w-full flex  items-center justify-between">
                <p>Department Risks</p>
                <div className="flex flex-row gap-4 items-center justify-center">
                  <div className="">
                    <TableSearchBar
                      searchTerm={searchTerm}
                      onSearchChange={setSearchTerm}
                      placeholder="Search risks..."
                    />
                  </div>
                </div>
              </div>
            </caption>
            <thead className="text-sm text-jet font-bold bg-gray-50 dark:bg-gray-700 dark:text-gray-400">
              {table.getHeaderGroups().map((headerGroup) => (
                <tr key={headerGroup.id}>
                  {headerGroup.headers.map((header) => {
                    const isSorted = header.column.getIsSorted();
                    return (
                      <th
                        scope="col"
                        key={header.id}
                        className="px-6 py-3"
                        aria-sort={
                          isSorted === "asc"
                            ? "ascending"
                            : isSorted === "desc"
                            ? "descending"
                            : "none"
                        }
                      >
                        {header.isPlaceholder ? null : (
                          <button
                            type="button"
                            className={`flex items-center gap-1 select-none ${
                              header.column.getCanSort()
                                ? "cursor-pointer"
                                : "cursor-default"
                            }`}
                            onClick={header.column.getToggleSortingHandler()}
                            title={
                              header.column.getCanSort() ? "Sort" : undefined
                            }
                          >
                            {flexRender(
                              header.column.columnDef.header,
                              header.getContext()
                            )}
                            {header.column.getCanSort() && (
                              <span className="text-xs">
                                {isSorted === "asc"
                                  ? "▲"
                                  : isSorted === "desc"
                                  ? "▼"
                                  : "⇅"}
                              </span>
                            )}
                          </button>
                        )}
                      </th>
                    );
                  })}
                </tr>
              ))}
            </thead>
            {isLoadingRisks ? (
              <tbody>
                <tr className="text-center">
                  <td colSpan={7} className="text-center">
                    <div className="flex justify-center items-center h-96">
                      <Loader size={"xl"} />
                    </div>
                  </td>
                </tr>
              </tbody>
            ) : (
              <tbody className="text-jet font-medium text-xs">
                {table.getRowModel().rows.map((row) => (
                  <tr
                    key={row.id}
                    className={`bg-gray border-b hover:bg-gray-100 dark:bg-gray-800 dark:border-gray-700 ${
                      highlightedRiskId === row.original.id ? "bg-gray-200" : ""
                    }`}
                  >
                    {row.getVisibleCells().map((cell) => (
                      <td className="px-6 py-4 align-top" key={cell.id}>
                        {flexRender(
                          cell.column.columnDef.cell,
                          cell.getContext()
                        )}
                      </td>
                    ))}
                  </tr>
                ))}
              </tbody>
            )}
          </table>

          {/* Pagination */}
          <div className="mt-4 pl-10 pr-10 pb-5 text-jet font-medium text-xs ">
            <nav aria-label="Page navigation">
              <ul className="flex justify-between">
                <li className="flex flex-row items-center">
                  <div>
                    <p>Show rows per page</p>
                  </div>
                  <div>
                    <select
                      className="ml-2 bg-gray-50 border border-caribbeanCurrent text-gray-900 text-xs rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                      onChange={(e) => setItemsPerPage(Number(e.target.value))}
                    >
                      <option>25</option>
                      <option>50</option>
                      <option>100</option>
                    </select>
                  </div>
                </li>
                {/* {Array.from({ length: totalPages }, (_, index) => (
              <li key={index}>
                <button
                  className={`px-3 py-2 leading-tight ${
                    currentPage === index + 1
                      ? "text-blue-600 bg-blue-50 border border-blue-300"
                      : "text-gray-500 bg-white border border-gray-300"
                  } hover:bg-gray-100 hover:text-gray-700 dark:bg-gray-800 dark:border-gray-700 dark:text-gray-400 dark:hover:bg-gray-700 dark:hover:text-white`}
                  onClick={() => handlePageChange(index + 1)}
                >
                  {index + 1}
                </button>
              </li>
            ))} */}
                <li className="flex flex-row gap-1 items-center text-gray-500">
                  <div>
                    <p>
                      {currentPage} of {totalPages === 0 ? 1 : totalPages}
                    </p>
                  </div>
                  <div>
                    <button
                      className="px-3 py-2 ml-0 leading-tight text-gray-500 bg-white border border-gray-300 rounded-l-lg rounded-r-lg hover:bg-gray-100 hover:text-gray-700 dark:bg-gray-800 dark:border-gray-700 dark:text-gray-400 dark:hover:bg-gray-700 dark:hover:text-white"
                      onClick={() => handlePageChange(currentPage - 1)}
                      disabled={currentPage === 1}
                    >
                      {"<"}
                    </button>
                  </div>
                  <div>
                    <button
                      className="px-3 py-2 leading-tight text-gray-500 bg-white border border-gray-300 rounded-r-lg rounded-l-lg hover:bg-gray-100 hover:text-gray-700 dark:bg-gray-800 dark:border-gray-700 dark:text-gray-400 dark:hover:bg-gray-700 dark:hover:text-white"
                      onClick={() => handlePageChange(currentPage + 1)}
                      disabled={currentPage === totalPages}
                    >
                      {">"}
                    </button>
                  </div>
                </li>
              </ul>
            </nav>
          </div>
        </div>
      </div>

      {/* drawers */}

      {/* score item risk */}
      {allRiskswithResponses.length > 0 && (
        <div
          id="drawer-assessment-risk-response"
          ref={editDrawerRef}
          className={`fixed top-0 right-0 z-50 h-screen p-4 overflow-y-auto transition-transform ${
            isEditDrawerOpen ? "translate-x-0" : "translate-x-full"
          } bg-white w-full md:w-1/4 dark:bg-gray-800`}
          tabIndex={-1}
          aria-labelledby="drawer-assessment-risk-response-label"
        >
          <h5
            id="drawer-label"
            className="inline-flex items-center mb-6 text-base font-semibold text-gray-500  dark:text-gray-400"
          >
            Invite Comments
          </h5>
          <button
            type="button"
            data-drawer-hide="drawer-assessment-risk-response"
            aria-controls="drawer-assessment-risk-response"
            className="text-gray-400 bg-transparent hover:bg-gray-200 hover:text-gray-900 rounded-lg text-sm w-8 h-8 absolute top-2.5 end-2.5 inline-flex items-center justify-center dark:hover:bg-gray-600 dark:hover:text-white"
            onClick={() => setIsEditDrawerOpen(false)}
          >
            <svg
              className="w-3 h-3"
              aria-hidden="true"
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 14 14"
            >
              <path
                stroke="currentColor"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                d="m1 1 6 6m0 0 6 6M7 7l6-6M7 7l-6 6"
              />
            </svg>
            <span className="sr-only">Close menu</span>
          </button>
          <form key={currentRiskDetails?.id}
            onSubmit={handleScoreResponses}
            className="border-2 border-dashed rounded-lg border-gray-300 dark:border-gray-600 mb-4 p-4"
          >
            <div className="mb-6">
              <label
                htmlFor="responseText"
                className="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
              >
                Risk Response
              </label>
              <textarea
                id="responseText"
                rows={4}
                disabled
                readOnly
                className="block p-2.5 w-full text-sm text-gray-900 bg-gray-50 rounded-lg border border-gray-300 focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                placeholder="Risk Response goes here..."
                defaultValue={
                  currentRiskDetails && currentRiskDetails.responseText
                    ? currentRiskDetails.responseText
                    : ""
                }
              ></textarea>
            </div>
            <div className="mb-6">
              <label
                htmlFor="riskGoals"
                className="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
              >
                Select Comment
              </label>
              <select
                id="riskGoals"
                className=" bg-gray-50 border border-caribbeanCurrent  text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                onChange={(e) => {
                  setCurrentRiskDetails((prevState: any) => ({
                    ...prevState,
                    responseTextScore: e.target.value,
                  }));
                }}
              >
                <option>Select Comment</option>
                {riskScores.map(([score, name]) => (
                  <option value={score} key={score}>
                    {score} {name}
                  </option>
                ))}
              </select>
            </div>
            {currentRiskDetails.responseTextScore <= 2 && (
              <div className="mb-6">
                <label
                  htmlFor="responseTextSuggestion"
                  className="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
                >
                  Your suggestion
                </label>
                <textarea
                  id="responseTextSuggestion"
                  rows={4}
                  className="block p-2.5 w-full text-sm text-gray-900 bg-gray-50 rounded-lg border border-gray-300 focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                  placeholder="Enter your suggestion here"
                  onChange={(e) => {
                    setCurrentRiskDetails((prevState: any) => ({
                      ...prevState,
                      responseTextSuggestion: e.target.value,
                    }));
                  }}
                ></textarea>
              </div>
            )}

            <button
              type="submit"
              className="justify-center items-center inline-flex text-white bg-caribbeanCurrent hover:bg-blue-800 w-full focus:ring-4 focus:ring-caribbeanCurrent font-medium rounded-lg text-sm px-5 py-2.5 mb-2 dark:bg-caribbeanCurrent dark:hover:bg-caribbeanCurrent focus:outline-none dark:focus:ring-caribbeanCurrent block"
              onClick={handleScoreResponses}
            >
              {isSubmittingScores ? <Loader size="sm" /> : "Submit Comments"}
            </button>
          </form>
        </div>
      )}
    </>
  );
}

export default RiskResponseScoring;
